var VectorUtils = {
    reverseVector: function (v) {
        return {
            x: -v.x,
            y: -v.y,
        };
    },
    vectorFromTo: function (v1, v2) {
        return {
            x: v2.x - v1.x,
            y: v2.y - v1.y,
        };
    },
    addVectorVector: function (v1, v2) {
        return {
            x: v1.x + v2.x,
            y: v1.y + v2.y,
        };
    },
    multiplyVectorScalar: function (v, length) {
        return {
            x: v.x * length,
            y: v.y * length,
        };
    },
    rotateVector90: function (v) {
        return {
            x: v.y * -1,
            y: v.x,
        };
    },
    normaliseVector: function (v) {
        var length = Math.sqrt((v.x * v.x) + (v.y * v.y));
        return {
            x: v.x / length,
            y: v.y / length,
        };
    },
    distancePointPoint: function (p1, p2) {
        var lengthX = p2.x - p1.x;
        var lengthY = p2.y - p1.y;
        return Math.sqrt((lengthX * lengthX) + (lengthY * lengthY));
    },
};
export default VectorUtils;
//# sourceMappingURL=vectorUtils.js.map